export default __webpack_public_path__ + "static/media/25081104.bc68c7fc.jpg";